import * as React from 'react';

import * as styles from './Footer.css';

interface IFooterProps {
  pagination?: React.ReactNode;
  printButton?: React.ReactNode;
}

export const Footer: React.FC<IFooterProps> = ({ pagination, printButton }) => {
  return (
    <div className={styles.footer} data-mark="OffersFooter">
      <div className={styles['footer-content']}>
        <div>{pagination}</div>
        <div className={styles['footer-actions']}>
          <div className={styles['print-button']} data-mark="Print">
            {printButton}
          </div>
        </div>
      </div>
    </div>
  );
};
